var map = {
	"./Block/AccordionBlock.tsx": [
		748,
		6969
	],
	"./Block/AnnualReportArchiveBlock.tsx": [
		7599,
		1342,
		7238
	],
	"./Block/AnnualReportTwoColBlock.tsx": [
		655,
		5726
	],
	"./Block/ArmpitLiftUpBlock.tsx": [
		789,
		1416
	],
	"./Block/BlogEntryTeaser.tsx": [
		9185,
		9104,
		8613
	],
	"./Block/CEOReviewHeroBlock.tsx": [
		2083,
		2846
	],
	"./Block/CVTeaser.tsx": [
		7866,
		4751
	],
	"./Block/CampaignLayer.tsx": [
		552
	],
	"./Block/CompanyIntroBlock.tsx": [
		4749,
		3752
	],
	"./Block/ContactBlock.tsx": [
		4358,
		3691
	],
	"./Block/ContainerBlock.tsx": [
		6777,
		655,
		7292
	],
	"./Block/ContainerBlockTypes/Accordion.tsx": [
		2165,
		655
	],
	"./Block/Errors/NetworkError.tsx": [
		5349,
		2557
	],
	"./Block/EventLiftupBlock.tsx": [
		8158,
		8169,
		8223,
		8613
	],
	"./Block/EventTimelineBlock.tsx": [
		8333,
		7760
	],
	"./Block/FinancialTargetsBlock.tsx": [
		6857,
		5936
	],
	"./Block/FrontpageMediaLiftupBlock.tsx": [
		6174,
		3020,
		6479,
		8225
	],
	"./Block/FrontpageShortcutBlock.tsx": [
		348,
		749
	],
	"./Block/FullWidthHighLightBlock.tsx": [
		2023,
		1210
	],
	"./Block/GoogleMapsBlock.tsx": [
		8014,
		5315
	],
	"./Block/GroupCompaniesBlock.tsx": [
		308,
		8361
	],
	"./Block/GroupCompaniesReportBlock.tsx": [
		8230,
		5655
	],
	"./Block/GroupCompanyLinkBlock.tsx": [
		2704,
		6569
	],
	"./Block/HeroBlock.tsx": [
		3286,
		8151
	],
	"./Block/HighchartsBlock.tsx": [
		8647,
		7050,
		5353,
		1951,
		7215,
		3590,
		520,
		3277
	],
	"./Block/IframeBlock.tsx": [
		8894,
		191,
		468
	],
	"./Block/Image/Media/ImageMediaData.tsx": [
		8825,
		3123,
		8992
	],
	"./Block/Image/Media/VectorImageMediaData.tsx": [
		7779,
		1426,
		6333
	],
	"./Block/ImageAndDetailsBlock.tsx": [
		1354,
		2075
	],
	"./Block/InderesQuestionnaireBlock.tsx": [
		9873,
		5372
	],
	"./Block/InterimReportArchiveBlock.tsx": [
		1194,
		3020,
		1342,
		2171,
		8225
	],
	"./Block/IrBlogTabsBlock.tsx": [
		2285,
		2890,
		2802,
		9104,
		4392,
		8613,
		3943
	],
	"./Block/KeyFiguresTableBlock.tsx": [
		2890,
		6827,
		1342,
		4855,
		4183
	],
	"./Block/KeyValuePairsWithHeadingBlock.tsx": [
		2875,
		1058
	],
	"./Block/LatestNewsBlock.tsx": [
		9790,
		8903,
		8613
	],
	"./Block/Media/PdfFile.tsx": [
		6236,
		6851,
		4258,
		8613
	],
	"./Block/OnPageNavigationBlock.tsx": [
		4582,
		6827,
		5148,
		9879
	],
	"./Block/OnetrustCookieSettingsBtnBlock.tsx": [
		2105,
		5808
	],
	"./Block/Page/BlogEntryPage.tsx": [
		8740,
		9104,
		2138,
		8613
	],
	"./Block/Page/CVPage.tsx": [
		8491,
		4751,
		2955
	],
	"./Block/Page/PresentationHighlightPage.tsx": [
		5052,
		2531,
		4158,
		8613
	],
	"./Block/Page/VideoAndAudioHighlightPage.tsx": [
		1438,
		2531,
		7854,
		8613
	],
	"./Block/SampoLinkBlock.tsx": [
		1744,
		1117
	],
	"./Block/SitemapBlock.tsx": [
		7253,
		6832
	],
	"./Block/StyleGuide/Icons.tsx": [
		8767,
		7409
	],
	"./Block/StyleGuide/LinkStylesAndTabs.tsx": [
		396,
		2890,
		2082
	],
	"./Block/StyleGuide/Tables.tsx": [
		5778,
		2654
	],
	"./Block/StyleGuide/Typography.tsx": [
		1694,
		5818
	],
	"./Block/StyleGuide/VerticalSpacing.tsx": [
		6688,
		6674
	],
	"./Block/SubscriptionFormBlock.tsx": [
		4909,
		2890,
		2616,
		4616,
		6611,
		990
	],
	"./Block/TabsBlock.tsx": [
		3266,
		2890,
		2802,
		8531
	],
	"./Block/TextBlock.tsx": [
		1753,
		3700
	],
	"./Block/TwitterBlock.tsx": [
		3501,
		7276,
		8613
	],
	"./Block/TwoColContentBlock.tsx": [
		6448,
		7082
	],
	"./Block/Video/Media/VideoFile.tsx": [
		2899,
		9007,
		7202
	],
	"./Block/VideoBlock.tsx": [
		2345,
		3020,
		2328,
		3568,
		8225
	],
	"./Common/ArchiveFilters/ArchiveFilters.tsx": [
		4891,
		5338,
		7710,
		3943
	],
	"./Common/Button.tsx": [
		269,
		2890
	],
	"./Common/Disclaimer/Disclaimer.tsx": [
		7348,
		2890,
		6827,
		134
	],
	"./Common/Disclosure/Disclosure.tsx": [
		9556,
		5338
	],
	"./Common/EventHero/EventHero.tsx": [
		7072,
		7324,
		1558,
		8613
	],
	"./Common/EventList/EventList.tsx": [
		6780,
		8837,
		5496,
		8613
	],
	"./Common/EventList/EventListItem.tsx": [
		4549,
		8837
	],
	"./Common/GlossaryService.tsx": [
		3624,
		5336
	],
	"./Common/ImageArchiveItem/ImageArchiveItem.tsx": [
		5926,
		4852,
		908,
		8613
	],
	"./Common/ImageGalleryModal/ImageGalleryModal.tsx": [
		6396,
		9220
	],
	"./Common/KeyFigureTable/KeyFiguresTable.tsx": [
		2423,
		4855
	],
	"./Common/Link.tsx": [
		1509
	],
	"./Common/Pageimage/PageImage.tsx": [
		3216,
		8372
	],
	"./Common/Presentation/Presentation.tsx": [
		754,
		7500,
		8613
	],
	"./Common/ReleasesMonthFilter/ReleasesMonthFilter.tsx": [
		5688,
		3900,
		8613
	],
	"./Common/Search/NavigationSearch.tsx": [
		1864
	],
	"./Common/Search/SearchFilter.tsx": [
		2188,
		2250,
		4008
	],
	"./Common/Search/SearchResultItem.tsx": [
		6536,
		6984,
		4898,
		222,
		8613
	],
	"./Common/Search/SearchSuggestionItem.tsx": [
		1207,
		6984,
		2101,
		222
	],
	"./Common/Shareticker/Shareticker.tsx": [
		2888
	],
	"./Common/SubscriptionForm/SubscriptionFormReleases.tsx": [
		2146,
		2890,
		2616,
		990
	],
	"./Common/SubscriptionForm/UnsubscribeForm.tsx": [
		652,
		2890,
		2616,
		4616,
		990
	],
	"./Common/UpcomingEvent/UpcomingEventComponent.tsx": [
		3655,
		8169
	],
	"./Common/VideoArchiveItem/VideoArchiveItem.tsx": [
		5606,
		4852,
		8613
	],
	"./Common/YoutubeModal/YoutubeModal.tsx": [
		9574,
		3020,
		8225
	],
	"./Image/Media/ImageMediaData.tsx": [
		7771,
		3123
	],
	"./Image/Media/VectorImageMediaData.tsx": [
		746,
		1426
	],
	"./Image/Media/WebImageMediaData.tsx": [
		971,
		3123,
		8413
	],
	"./Media/PdfFile.tsx": [
		5830,
		6851,
		8613
	],
	"./NavigationTree/NavigationItem.tsx": [
		4305
	],
	"./NavigationTree/NavigationTree.tsx": [
		4472
	],
	"./OnpageNavigation/DropdownNav.tsx": [
		6096,
		6827
	],
	"./OnpageNavigation/HistoryNav.tsx": [
		3023,
		5148
	],
	"./Page/BlogEntryPage.tsx": [
		1918,
		9736,
		3798,
		6724,
		5336,
		1849,
		3950,
		8613,
		5978
	],
	"./Page/CVPage.tsx": [
		5805,
		2890,
		9736,
		3798,
		6724,
		5336,
		2034,
		3950,
		2614,
		8613,
		5978,
		944
	],
	"./Page/CountryMapPage.tsx": [
		2541,
		2890,
		9736,
		3798,
		6724,
		5336,
		2802,
		9845,
		3950,
		9604,
		8613,
		5978
	],
	"./Page/EventPage.tsx": [
		5814,
		9736,
		3798,
		6724,
		7324,
		1761,
		3950,
		1558,
		8613,
		5978
	],
	"./Page/EventsPage.tsx": [
		9126,
		2890,
		9736,
		3798,
		6724,
		8372,
		2802,
		8837,
		5496,
		606,
		3950,
		8613,
		5978
	],
	"./Page/FolderPage.tsx": [
		6506,
		549
	],
	"./Page/GlossaryPage.tsx": [
		3582,
		9736,
		3798,
		6724,
		5336,
		8372,
		5273,
		3950,
		8613,
		5978
	],
	"./Page/GlossaryTermPage.tsx": [
		4728,
		5443
	],
	"./Page/HistoryPage.tsx": [
		9094,
		9736,
		3798,
		6724,
		5336,
		8372,
		7505,
		3950,
		8613,
		5978
	],
	"./Page/HomePage.tsx": [
		3439,
		9736,
		3798,
		6724,
		8372,
		828,
		3950,
		5978
	],
	"./Page/ImageArchivePage.tsx": [
		7629,
		2890,
		9736,
		3798,
		6724,
		5338,
		7710,
		4852,
		9220,
		908,
		626,
		3950,
		8613,
		5978,
		3943
	],
	"./Page/LandingPage.tsx": [
		3307,
		2890,
		9736,
		3798,
		6724,
		5336,
		8372,
		6827,
		134,
		6360,
		3950,
		8613,
		5978
	],
	"./Page/NavigationLinkPage.tsx": [
		8144,
		3003
	],
	"./Page/PresentationArchivePage.tsx": [
		8620,
		2890,
		9736,
		3798,
		6724,
		5338,
		7710,
		7500,
		6503,
		3950,
		8613,
		5978,
		3943
	],
	"./Page/PressReleasePage.tsx": [
		8962,
		9736,
		3798,
		6724,
		5336,
		5565,
		3950,
		8613,
		5978
	],
	"./Page/ReleaseSearchPage.tsx": [
		2713,
		2890,
		9736,
		3798,
		6724,
		5336,
		2802,
		3900,
		2270,
		3950,
		8613,
		5978
	],
	"./Page/ReportPage.tsx": [
		9344,
		9736,
		3798,
		6724,
		5336,
		8372,
		8107,
		3950,
		8613,
		5978
	],
	"./Page/SearchPage.tsx": [
		738,
		2890,
		6984,
		2250,
		4898,
		2101,
		8714,
		7903,
		222,
		4008,
		8613
	],
	"./Page/StyleGuidePage.tsx": [
		2747,
		2890,
		8372,
		7409,
		2654,
		2082,
		5818,
		6674,
		3368,
		8613
	],
	"./Page/VideoArchivePage.tsx": [
		8475,
		2890,
		9736,
		3798,
		6724,
		3020,
		5338,
		7710,
		4852,
		7256,
		3950,
		8225,
		8613,
		5978,
		3943
	],
	"./Placeholder.tsx": [
		4032
	],
	"./Shared/Breadcrumbs.tsx": [
		447,
		9736
	],
	"./Shared/Footer.tsx": [
		7844
	],
	"./Shared/Glossary.tsx": [
		3221,
		3798,
		3950,
		5978
	],
	"./Shared/Header.tsx": [
		2758
	],
	"./Shared/LanguageSelector.tsx": [
		3748
	],
	"./Shared/LoadingSpinner.tsx": [
		978
	],
	"./Shared/Navigation.tsx": [
		7579
	],
	"./Shared/PageTop.tsx": [
		2987,
		9736,
		6724
	],
	"./Shared/SampoLayout.tsx": [
		4953
	],
	"./Video/Media/VideoFile.tsx": [
		3813,
		9007
	],
	"./Video/Media/YoutubeVideo.tsx": [
		2640,
		3020,
		2328,
		8225
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7769;
module.exports = webpackAsyncContext;